<div class="wrapper">
  <div class="main-panel main-content">
    <app-header></app-header>
    <div class="center-content">
      <ng-container *ngIf="isNetworkOnline">
        <router-outlet (activate)="onActivate($event)"></router-outlet>
      </ng-container>
      <ng-container *ngIf="!isNetworkOnline">
        <div class="container no-network d-flex flex-column align-items-center justify-content-center vh-100 bg-white">
          <img src="" style="width: 500px;" alt="no internet Image" class="img-fluid mb-3">
          <a href="/" class="btn btn-primary mt-2" (click)="reloadPage()">Reload</a>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="life-sidebar">
    <app-sidebar></app-sidebar>
  </div>
  <!-- <div class="footer">
    <app-footer></app-footer>
  </div> -->
</div>